module.exports = __webpack_public_path__ + "static/information1-bf4d56545400e18fed758a81f604d245.png";